// User model for Group properties
export class Group {
  groupName: string;
  description: string;
  isInternalGroup : boolean;
  users: string[];
}
